import React from 'react'
import * as Components from '../components/memberships'

function PendingsPage() {
  return <Components.PendingsTable />
}
export default PendingsPage
